// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"loadingSpinner_spinnerContainer__yYExE","spinner":"loadingSpinner_spinner__51fEe","spin":"loadingSpinner_spin__zwGp0"};